<template>
  <Dialog :title="$t('Reordenar códigos')" v-model="show">
    <template v-slot:content>
      <div class="container_info_azul" style="border-radius: 5px; margin-top: 0 !important">
        <p>
          {{ $t("Con esta funcionalidad puedes reordenar los códigos de las ventas indicando el código de venta a partir del cual se van a ordenar en adelante.") }}
        </p>
        <p>
          {{ $t('Opcionalmente también puedes indicar un nuevo número de ticket que se sustituirá por el ticket inicial.') }}
        </p>
      </div>
      <v-row class="ma-0">
        <ValidationObserver ref="ValidationObserver">
          <v-form ref="form" lazy-validation>
            <v-col cols="12">
              <ValidationProvider
                  rules="required|max:4|min:4|min_value:2000"
                  :name="$t('Año')"
                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">
                  <v-text-field
                      v-model="anyo"
                      :label="$t('Año')"
                      type="number"
                      outlined
                      dense
                      hide-details
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>

<!--            <v-col cols="12">-->
<!--              <ValidationProvider-->
<!--                  rules="required"-->
<!--                  :name="$t('número ticket')"-->
<!--                  v-slot="{ errors, classes }"-->
<!--              >-->
<!--                <div class="control" :class="classes">-->
<!--                  <v-text-field-->
<!--                      v-model="codigo_inicial"-->
<!--                      :label="$t('Número de ticket inicial (sin serie)')"-->
<!--                      type="number"-->
<!--                      outlined-->
<!--                      dense-->
<!--                      hide-details-->
<!--                  />-->
<!--                </div>-->
<!--                <span class="error&#45;&#45;text">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </v-col>-->

            <v-col cols="12">
              <ValidationProvider
                  rules="required"
                  :name="$t('número ticket inicial')"
                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">
                  <v-text-field
                      v-model="nuevo_codigo_inicial"
                      :label="$t('Nuevo número de ticket inicial')"
                      type="number"
                      outlined
                      dense
                      hide-details
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-form>
          <div class="container_warning_amarillo" style="border-radius: 5px;">
            <p>
              {{ $t("Atención, esta operación no se puede deshacer, revisa las opciones detalladamente y si tienes cualquier duda contacta con el servicio técnico.") }}
            </p>
          </div>
        </ValidationObserver>
      </v-row>
    </template>
    <template v-slot:right-action>
      <v-btn @click="reordenar_ventas" small class="primary white--text">
        <v-icon small>mdi-reload</v-icon>
        {{ $t('Reordenar') }}
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";

export default {
  name: "FormReordenarCodigos",

  data() {
    return {
      anyo: this.$moment().format('YYYY'),
      codigo_inicial: 0,
      nuevo_codigo_inicial: 0
    }
  },

  components: {
    ValidationObserver,
    ValidationProvider
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    async reordenar_ventas() {
      try {
        if (this.$refs.form.validate()) {
          await this.$store.dispatch('venta/reordenar_codigos',
              {codigo_inicial: this.codigo_inicial, nuevo_codigo_inicial: this.nuevo_codigo_inicial, anyo: this.anyo});
        }
        this.show = false
        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
        this.$emit('refrescar_ventas')
      }
      catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    }
  },

  props: ['value']
}
</script>
